import React from "react"
/*import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';*/
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

/*import { LightgalleryProvider, LightgalleryItem } from "react-lightgallery";
import "../css/lightgallery.css";

const PhotoItem = ({ image, group, alt }) => (
  <div style={{  }} className="page-Image">
    <LightgalleryItem group={group} src={image}>
      <img src={image} alt={alt} style={{  }} />
    </LightgalleryItem>
  </div>
);*/

const pageData = data => (

  
  < Layout >

    <SEO
      title={`Chofly Elite | ${data.data.page.name}`}
      ogTitle={`Chofly Elite | ${data.data.page.name}`}
      ogURL="https://choflyelite-legacy.netlify.com"
      ogDescription={`Chofly Elite | ${data.data.page.name} | ${data.data.page.heading}`}
      ogURL={data.data.page ? `https://choflyelite-legacy.netlify.com/${data.data.page.slug}/` : ""}
      ogImage={data.data.page.featured_image && data.data.page.featured_image[0] ? `${'https://api.flotiq.com'}/image/400x0/${data.data.page.featured_image[0].id}.${data.data.page.featured_image[0].extension}` : ""}
      keywords={['Chofly Elite', 'ChoseN', 'Raid', 'Raid Shadow Legends', 'Twitch Streamer', 'YouTuber', 'Content Creator', 'YouTube Content Creator', 'Plarium Moderator',]}
    />

    <div className="container page">
        <br />
        <h1>{data.data.page.heading ? `${data.data.page.heading}` : `${data.data.page.name}`}</h1>

        <div className="pageContent">
        <section dangerouslySetInnerHTML={{ __html: data.data.page.content}} />
        </div>

    </div>

</Layout >
)

export default pageData

export const query = graphql`
  query pageBySlug($slug: String!) {
    page(slug: {eq: $slug}) {
      id
      slug
      name
      heading
      content
      featured_image {
        id
        extension
      }
    }

    header {
      social_media_logo_links {
        logo {
          url
          type
          width
          size
          height
          id
          fileName
          extension
        }
        text_next_to_logo
        hover_text
        link
      }
    }
  }
`
